import { APP_NAME } from '../consts'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import {
  getAppNameWithVersion,
  getAppUrl,
  getBiDefaults as _getBiDefaults,
} from '@wix/wix-data-client-common-standalone'

export const getBiDefaults = ({
  editorSdkProxy,
  appVersion = getAppNameWithVersion(getAppUrl(APP_NAME)),
}: {
  editorSdkProxy: EditorSDK
  appVersion?: string
}) =>
  _getBiDefaults({
    editorSdkProxy,
    appVersion,
  })
